package com.karawek.core.auth.model

import kotlin.time.ExperimentalTime
import kotlin.time.Instant

@OptIn(ExperimentalTime::class)
data class AuthSession(
    val userId: String,
    val sessionToken: String,
    val sessionJwt: String? = null,
    val sessionId: String? = null,
    val sessionExpiration: Instant? = null,
)
